import React from 'react';

/* eslint-disable max-len */

export const MountainMarker = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="31" height="42" viewBox="0 0 31 42" fill={props.fillColor ? props.fillColor : '#c80000'}>
    <defs>
      <filter id="Path_567" x="-0.5" y="1.669" width="32" height="42.046" filterUnits="userSpaceOnUse">
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="1.5" result="blur" />
        <feFlood floodOpacity="0.161" />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
      <clipPath id="clip-marker-background_1">
        <rect width="31" height="42" />
      </clipPath>
    </defs>
    <g id="marker-background_1" data-name="marker-background – 1" clipPath="url(#clip-marker-background_1)">
      <g id="Component_1_2" data-name="Component 1 – 2">
        <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
        <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_567)">
          <path
            id="Path_567-2"
            data-name="Path 567"
            d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
            transform="translate(-1748.6 -1197.14)"
            stroke="#fff"
            strokeWidth="2"
          />
        </g>
      </g>
      <g id="Group_71" data-name="Group 71" transform="translate(-34 -323)">
        <rect id="Rectangle_16" data-name="Rectangle 16" width="15" height="15" transform="translate(42 330)" fill="#ff00f5" opacity="0" />
        <path
          id="mountain"
          d="M10.842,7.2,5.923.229a.577.577,0,0,0-.92,0L.084,7.2a.46.46,0,0,0-.02.508.557.557,0,0,0,.48.259h9.839a.557.557,0,0,0,.48-.259.46.46,0,0,0-.02-.508ZM5.463,1.419,6.921,3.485H5.463l-1.093,1-.65-.592Z"
          transform="translate(44.003 332)"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
);

export default {};
